/** Superficie pública Expenses. Re-exporta desde domain-api, infra-api, app-api + UI directa. */
export * from './domain-api';
export * from './infra-api';
export * from './app-api';

// UI — se mantiene directo en public-api
export { ExpenseRegisterModal } from './components/ExpenseRegisterModal';
export type { ActiveCashSessionInfo } from './components/expensePaymentFlow';
export { isoDateToPaidAt } from './components/expensePaymentFlow';
export type { ExpenseRegisterSubmitInput } from './screens/expenseRegisterSubmitTypes';
export type { ExpenseCreatePaymentIntent } from './components/expenseSettlementMethods';
export { ExpensesScreenHeader } from './components/ExpensesScreenHeader';
export { ExpensesFiltersPanel } from './components/ExpensesFiltersPanel';
export { ExpensesTable } from './components/ExpensesTable';
export { ExpenseDetailModal } from './components/ExpenseDetailModal';
export { ExpensePaymentHistoryRowCard } from './components/ExpensePaymentHistoryRowCard';
export { ExpensePaymentsHistoryPanel } from './components/ExpensePaymentsHistoryPanel';
export { ExpensePaymentsFiltersPanel } from './components/ExpensePaymentsFiltersPanel';
export { ExpenseSettleModal } from './components/ExpenseSettleModal';
export { ExpensePaidFormChoice } from './components/expensePaymentFlow';
export { ExpenseSettleMethod } from './components/expenseSettlementMethods';
export { ExpenseRowCard } from './components/ExpenseRowCard';
export { ExpensePaymentStatusChoice } from './components/expensePaymentFlow';
export { ExpensesScreen } from './screens/ExpensesScreen';
